import { DEFAULT_COUNTRY } from "../shared/types";
import { OwnerType, RegulatoryInformationModel } from "./types";
import { defaultAddress } from "../shared/defaults";
import {
  CompanyClassification,
  ControllerIdentification,
} from "../../api/commercial/generated-types";

// We create new object with function because Formik has some issues with "touched" with objects having nested objects.
export const createDefaultOwnerData: () => OwnerType = () => ({
  nationality: DEFAULT_COUNTRY,
  birthdate: "",
  gender: "",
  firstName: "",
  lastName: "",
  fullStreet: "",
  address: defaultAddress(),
  isSameAsAdmin: false,
});

export const defaults: RegulatoryInformationModel = {
  isOwnerSameAsAdmin: "yes",
  admin: createDefaultOwnerData(),
  beneficialOwner: {
    admin: { ...createDefaultOwnerData(), isSameAsAdmin: true },
    other: createDefaultOwnerData(),
  },
  controllingOwners: {
    admin: [{ ...createDefaultOwnerData(), isSameAsAdmin: true }],
    other: [createDefaultOwnerData()],
  },
  companyClassification: "" as CompanyClassification,
  controllerIdentification: "" as ControllerIdentification,
  hasOwnOffice: false,
  employsOwnStaff: false,
};
